import Vue from 'vue'
import i18n from '../i18n/index'

export const geocodeService = {
  geocode,
  getCountryCodes
}

function geocode (city) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get('https://nominatim.openstreetmap.org/search',
      {
        params: {
          addressdetails: '1',
          city: city,
          format: 'json',
          countrycodes: getCountryCodes().join()
        }
      })
      .then(response => {
        let results = []
        if (response && response.data) {
          if (response.data.length > 0) {
            response.data.forEach(function (result) {
              let id = result.place_id

              let city = result.address.city
              if (!city) {
                city = result.address.town
              }
              if (!city) {
                city = result.address.place
              }
              if (!city) {
                city = result.address.hamlet
              }
              if (!city) {
                city = result.address.isolated_dwelling
              }
              if (!city) {
                city = result.address.city_district
              }
              if (!city) {
                city = result.address.suburb
              }
              if (!city) {
                city = result.address.village
              }
              if (!city) {
                city = result.address.county
              }
              let country = result.address.country_code
              let name = city + ', ' + i18n.t('countries.' + country)

              let lat = result.lat
              let lng = result.lon

              let exists = results.filter(function (filter) {
                return filter.city === city && filter.country === country
              }).length > 0

              if (!exists && city) {
                results.push({
                  id: id,
                  name: name,
                  city: city,
                  country: country,
                  lat: lat,
                  lng: lng
                })
              }
            })
          }
        }
        resolve(results)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function getCountryCodes () {
  return ['at', 'be', 'nl', 'fr', 'de', 'cz', 'dk', 'gr', 'ie', 'it', 'lu', 'es', 'se', 'gb', 'pt', 'pl', 'ro', 'bg', 'si', 'fi', 'hr', 'hu', 'sk', 'lt', 'mt', 'lt', 'lv', 'ee']
}



// WEBPACK FOOTER //
// ./src/services/geocode.service.js